module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2018_de-a97cc9dcfab060bc861755df30e1f2b6.jpg";